import { render, staticRenderFns } from "./NewsSource.vue?vue&type=template&id=06c2b20e&scoped=true&"
import script from "./NewsSource.vue?vue&type=script&lang=js&"
export * from "./NewsSource.vue?vue&type=script&lang=js&"
import style0 from "./NewsSource.vue?vue&type=style&index=0&id=06c2b20e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c2b20e",
  null
  
)

export default component.exports